import { Component, Input } from "@angular/core";
import { DeckCardSearchComponent } from "./deck-card-search.component";
import { isMobileScreen } from "@ponder-shared/utils/screenBreakpoints";
import { Deck, DeckLayer } from "@apiserver-rest/ponder-data-client-base";
import { DeckBaseComponent } from "../deck-base.component";
import { NgClass } from "@angular/common";
import { DeckEditOptionsComponent } from "./deck-edit-options.component";
import { DeckCopyComponent } from "./deck-copy.component";
import { DeckDeleteComponent } from "./deck-delete.component";
import { DeckExportComponent } from "./deck-export-modal.component";
import { DeckValueStatsComponent } from "./deck-value-stats.component";

@Component({
    selector: "deck-tabs",
    imports: [
        DeckCardSearchComponent,
        DeckValueStatsComponent,
        DeckEditOptionsComponent,
        DeckCopyComponent,
        DeckExportComponent,
        DeckDeleteComponent,
        NgClass
    ],
    templateUrl: "./deck-tabs.component.html"
})
export class DeckTabsComponent {
    @Input({ required: true }) public deck!: Deck;
    @Input({ required: true }) public deckComponent!: DeckBaseComponent;
    @Input({ required: true }) public currentLayer?: DeckLayer;
    
    public isMobileScreen(): boolean {
        return isMobileScreen();
    }
}